import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BypassInterceptorContext } from 'src/app/interceptors/http.interceptor';

@Injectable({
  providedIn: 'root',
})
export class BypassApiService {
  token = localStorage.getItem('auth-token');
  constructor(private http: HttpClient) { }

  request<T>({
    method,
    endpoint,
    body = null,
    params = undefined,
    headers = {},
    bypassInterceptor = true,
  }: {
    method: 'GET' | 'POST' | 'PUT' | 'DELETE';
    endpoint: string;
    body?: any;
    params?: HttpParams | { [param: string]: string | number | boolean };
    headers?: { [header: string]: string };
    bypassInterceptor?: boolean;
  }): Observable<T> {
    const httpHeaders = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.token}`,
      ...headers,
    });

    let context = new HttpContext();
    if (bypassInterceptor) {
      context = context.set(BypassInterceptorContext, true);
    }

    const options = {
      headers: httpHeaders,
      context,
      params,
      body,
    };

    switch (method) {
      case 'GET':
        return this.http.get<T>(endpoint, { headers: httpHeaders, params, context });
      case 'POST':
        return this.http.post<T>(endpoint, body, { headers: httpHeaders, context });
      case 'PUT':
        return this.http.put<T>(endpoint, body, { headers: httpHeaders, context });
      case 'DELETE':
        return this.http.delete<T>(endpoint, { headers: httpHeaders, params, context });
      default:
        throw new Error(`Unsupported method: ${method}`);
    }
  }
}
